module.exports = "/lucky-balls/img/drum/drum_loop_025.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/drum/drum_loop_025.png
// module id = 1040
// module chunks = 0